import { Storage } from '../modules/storage/storage';

interface AsyncStorage {
	getItem: (key: string) => Promise<string | null>;
	setItem: (key: string, value: string) => Promise<void>;
	removeItem: (key: string) => Promise<void>;
}

export class QueryCacheStorageAdapter implements AsyncStorage {
	constructor(private readonly storage: Storage) {}

	public async getItem(key: string): Promise<string | null> {
		return this.storage.get(key);
	}

	public async setItem(key: string, value: string): Promise<void> {
		await this.storage.set({ [key]: value });
	}

	public async removeItem(key: string): Promise<void> {
		await this.storage.remove(key);
	}
}
